import script from "./boardDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./boardDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./boardDetailPage.vue?vue&type=style&index=0&id=64339038&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64339038"]])

export default __exports__